import { Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { getBookDate } from '@fable/utils'

interface Props {
  published_date: string
}

export const BookDetailPreorderNote = ({ published_date }: Props) => {
  const { colors } = useTheme()

  return (
    <Text
      className={css`
        margin-top: 25px;
        font-weight: 500;
      `}
      type="label"
      sizing="L"
      color={colors.uiPewterGrey}
    >
      This ebook will be auto-delivered to your bookshelf on the Fable app on{' '}
      {getBookDate(published_date)}
    </Text>
  )
}
